import { EFinancingProgram } from '@if/core/types'
import { Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import FundingSummaryButton from './FundingSummaryButton'

interface Props {
  activationDate: string
  id: string
  financingProgramId: EFinancingProgram
}
const FundingLoanCreated = ({ activationDate, id, financingProgramId }: Props) => {
  const { t } = useTranslation()
  return (
    <div>
      <Typography variant="subtitle1">{t('viewCreditApplication.activationDate')}</Typography>
      <Typography variant="body1">{activationDate}</Typography>
      <br />
      <Typography variant="body1">{t('viewCreditApplication.fundingAwaitingActivationDate')}</Typography>
      <br />
      <br />
      <FundingSummaryButton id={id} financingProgramId={financingProgramId} disabled={false} />
    </div>
  )
}

export default FundingLoanCreated
